<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="500px"
    @close="$router.replace('/lists')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="currency"
      :rules="rules"
      ref="currencyForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="name"
        label="Név"
        :error="errors.name ? errors.name[0] : null"
      >
        <el-input v-model="currency.name"/>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/lists')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    props: ['type', 'currencyId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        currency: {},
        errors: {
          name: null,
        },
        rules: {
          name :[
            { required: true, message: 'Név megadása kötelező', trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új Valuta';
        } else if (this.type === 'update') {
          return 'Valuta módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadás';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },

    methods: {
      async add() {
        this.$refs['currencyForm'].validate(async valid => {
          if(valid) {
            this.buttonLoading = true;
            this.errors.name = null;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('currency/add', this.currency);
              } else if (this.type === 'update') {
                await this.$store.dispatch('currency/update', this.currency);
              }
              this.$store.dispatch('currency/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/lists');
            } catch (e) {
                if(e.data && e.data.errors) {
                  this.errors = e.data.errors;
                }
            }
            this.buttonLoading = false;
          }
        });
      }
    },

    async mounted() {
      this.loading = true;
      if(this.currencyId) {
        this.currency = await this.$store.dispatch('currency/fetch', this.currencyId);
      }
      this.loading = false;
    }
  }
</script>
